import * as React from "react";
import BuyPermitsExitOrderModalForm from "../../Forms/buypermits/BuyPermitsExitOrderForm";
import BaseModal, { BaseModalContent } from "../BaseModal";

const BuyPerimtsExitOrderModal=(props)=>{ 
   const {isOpenExitOrderModal,CancelBuyPermitsExitOrderModal,ConfirmBuyPermitsExitOrderModal} = props;
   
    return(
        <>
            <BaseModal
                title="EXIT ORDER"
                align="center"
                open={isOpenExitOrderModal}
                onClose={CancelBuyPermitsExitOrderModal}
                with={200}                
            >
                <BaseModalContent>
                   <BuyPermitsExitOrderModalForm 
                      CancelBuyPermitsExitOrderModal={CancelBuyPermitsExitOrderModal}
                      ConfirmBuyPermitsExitOrderModal={ConfirmBuyPermitsExitOrderModal}
                   />
                </BaseModalContent>
            </BaseModal>
        </>
    )
}
export default BuyPerimtsExitOrderModal;